import axiosBase from './base'
import axios from 'axios'

export const postFile = (payload: any): Promise<any> => axiosBase.post('/api/file', payload)
export const uploadAWS = (url: string, payload: any): Promise<any> => axios.post(url, payload)
